import React, {RefObject} from "react";
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {RankingCreationStep} from "./RankingCreationStep";

import titleGraph from "../../../images/step_3.svg";

interface IProps {
    scrollRefElem?: RefObject<HTMLDivElement | null>;
    className?: string;
}

export const RankingCreationSteps2022 = (props: IProps) => {
    const {scrollRefElem, className} = props;

    const rankingCreationSteps = [
        "Bazujemy na informacjach, otrzymywanych co miesiąc od ponad 500 tys. użytkowników.",
        "Zbieramy informacje o tym, które inwestycje są najbardziej interesujące. Uwzględniamy zapytania do dewelopera, wykonane telefony czy liczbę obejrzanych ofert w danej inwestycji.",
        "Nasz algorytm tworzy finalne zestawienie, na bazie którego powstaje Ranking Inwestycji.",
        "Ogłaszamy trzy najlepsze inwestycje oraz przyznajemy wyróżnienia w danym regionie."
    ];

    return (
        <section className={cx(creationStepsWrap, className)} ref={scrollRefElem}>
            <div className={creationSteps}>
                <Text align="center" as="h2" variant="headline_3" mb={4}>
                    Zobacz, jak powstał ranking
                </Text>
                <div className={stepsWrap}>
                    <img className={stepsImg} src={titleGraph} alt="Jak powstał ranking" />
                    <ul className={steps}>
                        {rankingCreationSteps.map((stepText, index) => (
                            <RankingCreationStep key={stepText.substring(0, 3)} text={stepText} place={index + 1} />
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
};

const creationStepsWrap = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});

const creationSteps = css({
    maxWidth: "1128px"
});

const stepsWrap = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,
    alignItems: "center",
    justifyContent: "center",

    md: {
        flexDirection: "row"
    }
});

const stepsImg = css({
    width: "336px",

    md: {
        width: "auto",
        flex: "1 0 600px"
    }
});

const steps = css({
    paddingLeft: 0,
    listStyle: "none",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: 3,

    md: {
        flexDirection: "column"
    }
});
import React, {RefObject} from "react";
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {RankingCreationStep} from "./RankingCreationStep";

import titleGraph from "../../../images/step_3.svg";

interface IProps {
    scrollRefElem?: RefObject<HTMLDivElement | null>;
    className?: string;
}

export const RankingCreationSteps2022 = (props: IProps) => {
    const {scrollRefElem, className} = props;

    const rankingCreationSteps = [
        "Bazujemy na informacjach, otrzymywanych co miesiąc od ponad 500 tys. użytkowników.",
        "Zbieramy informacje o tym, które inwestycje są najbardziej interesujące. Uwzględniamy zapytania do dewelopera, wykonane telefony czy liczbę obejrzanych ofert w danej inwestycji.",
        "Nasz algorytm tworzy finalne zestawienie, na bazie którego powstaje Ranking Inwestycji.",
        "Ogłaszamy trzy najlepsze inwestycje oraz przyznajemy wyróżnienia w danym regionie."
    ];

    return (
        <section className={cx(creationStepsWrap, className)} ref={scrollRefElem}>
            <div className={creationSteps}>
                <Text align="center" as="h2" variant="headline_3" mb={4}>
                    Zobacz, jak powstał ranking
                </Text>
                <div className={stepsWrap}>
                    <img className={stepsImg} src={titleGraph} alt="Jak powstał ranking" />
                    <ul className={steps}>
                        {rankingCreationSteps.map((stepText, index) => (
                            <RankingCreationStep key={stepText.substring(0, 3)} text={stepText} place={index + 1} />
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
};

const creationStepsWrap = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});

const creationSteps = css({
    maxWidth: "1128px"
});

const stepsWrap = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,
    alignItems: "center",
    justifyContent: "center",

    md: {
        flexDirection: "row"
    }
});

const stepsImg = css({
    width: "336px",

    md: {
        width: "auto",
        flex: "1 0 600px"
    }
});

const steps = css({
    paddingLeft: 0,
    listStyle: "none",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: 3,

    md: {
        flexDirection: "column"
    }
});
